const appConfig = {
  basename: "/",
  defaultPath: "/world-ranking",
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  restrictedGroupId: process.env.REACT_APP_RESTRICTED_GROUP_ID,
  fullAccessGroupId: process.env.REACT_APP_FULL_ACCESS_GROUP_ID,
  authScopes: [process.env.REACT_APP_AUTH_SCOPES],
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  simulationToolApi: process.env.REACT_APP_SIMULATION_TOOL_API,
  microsoftGraphBaseUrl: process.env.REACT_APP_GRAPH_BASE_URL,
};

export default appConfig;
